import _ from "lodash";

export const GOOGLE_FONTS = [
    "ABeeZee",
    "Abel",
    "Abril Fatface",
    "Acme",
    "Advent Pro",
    "Alata",
    "Alegreya",
    "Alegreya Sans",
    "Alegreya Sans SC",
    "Aleo",
    "Alfa Slab One",
    "Alice",
    "Almarai",
    "Amatic SC",
    "Amiri",
    "Antic Slab",
    "Anton",
    "Antonio",
    "Architects Daughter",
    "Archivo",
    "Archivo Black",
    "Archivo Narrow",
    "Arimo",
    "Arsenal",
    "Arvo",
    "Asap",
    "Asap Condensed",
    "Assistant",
    "Baloo 2",
    "Bangers",
    "Barlow",
    "Barlow Condensed",
    "Barlow Semi Condensed",
    "Be Vietnam Pro",
    "Bebas Neue",
    "Bitter",
    "Bodoni Moda",
    "Bree Serif",
    "Cabin",
    "Cairo",
    "Cantarell",
    "Cardo",
    "Carter One",
    "Catamaran",
    "Caveat",
    "Chakra Petch",
    "Changa",
    "Chivo",
    "Cinzel",
    "Comfortaa",
    "Commissioner",
    "Concert One",
    "Cookie",
    "Cormorant",
    "Cormorant Garamond",
    "Courgette",
    "Crete Round",
    "Crimson Pro",
    "Crimson Text",
    "Cuprum",
    "DM Sans",
    "DM Serif Display",
    "DM Serif Text",
    "Dancing Script",
    "Didact Gothic",
    "Domine",
    "Dosis",
    "EB Garamond",
    "El Messiri",
    "Encode Sans",
    "Exo",
    "Exo 2",
    "Faustina",
    "Figtree",
    "Fira Sans",
    "Fira Sans Condensed",
    "Fira Sans Extra Condensed",
    "Fjalla One",
    "Francois One",
    "Frank Ruhl Libre",
    "Gelasio",
    "Gloria Hallelujah",
    "Gothic A1",
    "Great Vibes",
    "Gruppo",
    "Handlee",
    "Heebo",
    "Hind",
    "Hind Madurai",
    "Hind Siliguri",
    "IBM Plex Mono",
    "IBM Plex Sans",
    "IBM Plex Sans Arabic",
    "IBM Plex Sans Condensed",
    "IBM Plex Serif",
    "Inconsolata",
    "Indie Flower",
    "Inter",
    "Josefin Sans",
    "Josefin Slab",
    "Jost",
    "Kalam",
    "Kanit",
    "Karla",
    "Kaushan Script",
    "Khand",
    "Kosugi Maru",
    "Lato",
    "Lexend",
    "Lexend Deca",
    "Libre Baskerville",
    "Libre Franklin",
    "Lilita One",
    "Lobster",
    "Lobster Two",
    "Lora",
    "Luckiest Guy",
    "M PLUS 1p",
    "M PLUS Rounded 1c",
    "Manrope",
    "Marcellus",
    "Marck Script",
    "Martel",
    "Mate",
    "Mate SC",
    "Maven Pro",
    "Merriweather",
    "Merriweather Sans",
    "Mitr",
    "Montserrat",
    "Montserrat Alternates",
    "Mr Dafoe",
    "Mukta",
    "Mukta Malar",
    "Mulish",
    "Nanum Gothic",
    "Nanum Myeongjo",
    "Neucha",
    "Neuton",
    "News Cycle",
    "Noticia Text",
    "Noto Color Emoji",
    "Noto Kufi Arabic",
    "Noto Sans",
    "Noto Sans Arabic",
    "Noto Sans Display",
    "Noto Sans HK",
    "Noto Sans JP",
    "Noto Sans KR",
    "Noto Sans SC",
    "Noto Sans TC",
    "Noto Sans Thai",
    "Noto Serif",
    "Noto Serif JP",
    "Noto Serif KR",
    "Noto Serif TC",
    "Nunito",
    "Nunito Sans",
    "Old Standard TT",
    "Open Sans",
    "Orbitron",
    "Oswald",
    "Outfit",
    "Overpass",
    "Oxygen",
    "PT Sans",
    "PT Sans Caption",
    "PT Sans Narrow",
    "PT Serif",
    "Pacifico",
    "Passion One",
    "Pathway Gothic One",
    "Patrick Hand",
    "Patua One",
    "Paytone One",
    "Permanent Marker",
    "Philosopher",
    "Play",
    "Playfair Display",
    "Playfair Display SC",
    "Plus Jakarta Sans",
    "Poiret One",
    "Poppins",
    "Prata",
    "Press Start 2P",
    "Prompt",
    "Public Sans",
    "Quattrocento",
    "Quattrocento Sans",
    "Questrial",
    "Quicksand",
    "Rajdhani",
    "Raleway",
    "Rambla",
    "Rammetto One",
    "Rasa",
    "Red Hat Display",
    "Red Hat Text",
    "Reem Kufi",
    "Rhodium Libre",
    "Roboto",
    "Roboto Condensed",
    "Roboto Mono",
    "Roboto Slab",
    "Rokkitt",
    "Rosario",
    "Rubik",
    "Rubik Mono One",
    "Ruda",
    "Rufina",
    "Ruslan Display",
    "Saira",
    "Saira Condensed",
    "Saira Extra Condensed",
    "Sarabun",
    "Sarala",
    "Sarina",
    "Sawarabi Gothic",
    "Sen",
    "Shadows Into Light",
    "Shadows Into Light Two",
    "Shippori Mincho",
    "Sigmar One",
    "Signika",
    "Signika Negative",
    "Simonetta",
    "Spectral",
    "Spectral SC",
    "Spinnaker",
    "Squada One",
    "Spectral",
    "Spectral SC",
    "Spinnaker",
    "Squada One",
    "Staatliches",
    "Stalemate",
    "Suez One",
    "Sumana",
    "Sunflower",
    "Sura",
    "Swanky and Moo Moo",
    "Syncopate",
    "Tajawal",
    "Tangerine",
    "Taprom",
    "Teko",
    "Tenali Ramakrishna",
    "Text Me One",
    "Thasadith",
    "Tienne",
    "Tillana",
    "Timmana",
    "Titillium Web",
    "Tomorrow",
    "Train One",
    "Trebuchet MS",
    "Trirong",
    "Trocchi",
    "Turret Road",
    "Ubuntu",
    "Ubuntu Condensed",
    "Ubuntu Mono",
    "Uncial Antiqua",
    "Underdog",
    "Unica One",
    "Unna",
    "Vampiro One",
    "Varela",
    "Varela Round",
    "Varta",
    "Viga",
    "Vollkorn",
    "Wallpoet",
    "Work Sans",
    "Yanone Kaffeesatz",
    "Yeseva One",
    "Yesteryear",
    "Zilla Slab"
];

const cssClasses = GOOGLE_FONTS.map((font, index) => {
    return `
.gfont-${_.kebabCase(font)} {
   font-family: '${font}', sans-serif;
}
`;
});

export const DYNAMIC_CSS_GOOGLE_FONTS = cssClasses.join('\n');
